import { EnrollTypeBE } from "../types";

const LABELS: Record<EnrollTypeBE, string> = {
  TOP: "Amministrata",
  TOP_MANDATORY: "Amministrata obbligatoria",
  AUTO: "Auto-iscrizione",
  BOTTOM: "Auto-iscrizione con approvazione",
  PRE_AUTO: "Autonoma",
  PRE_BOTTOM: "Autonoma con approvazione",
};

export const formatEnrollTypeLabel = (enrollType?: string | null): string => {
  if (!enrollType) return "";
  const key = enrollType.toUpperCase() as EnrollTypeBE;
  return LABELS[key] ?? enrollType;
};
